module.exports = __webpack_public_path__ + "img/profits.47947abe.png";